import ReactDOMServer from "react-dom/server";
export default (elementJSX) => {
    const htmlString = ReactDOMServer.renderToStaticMarkup(elementJSX);
    const htmlDocument = new DOMParser().parseFromString(htmlString, "text/html");
    const htmlElement = htmlDocument.getRootNode().body.firstChild;
    return {
        htmlElement,
        htmlString
    };
};
